export interface CountryData {
    name: string;
    iso: string;
    ddi: string;
    mask?: string;
}

export const ALL_COUNTRIES: CountryData[] = [
    { name: "Afghanistan", iso: "af", ddi: "93" },
    { name: "Albania", iso: "al", ddi: "355" },
    { name: "Algeria", iso: "dz", ddi: "213" },
    { name: "American Samoa", iso: "as", ddi: "1" },
    { name: "Andorra", iso: "ad", ddi: "376" },
    { name: "Angola", iso: "ao", ddi: "244" },
    { name: "Anguilla", iso: "ai", ddi: "1" },
    { name: "Antigua and Barbuda", iso: "ag", ddi: "1" },
    { name: "Argentina", iso: "ar", ddi: "54", mask: "(99) 9999-9999" },
    { name: "Armenia", iso: "am", ddi: "374" },
    { name: "Aruba", iso: "aw", ddi: "297" },
    { name: "Australia", iso: "au", ddi: "61" },
    { name: "Austria", iso: "at", ddi: "43" },
    { name: "Azerbaijan", iso: "az", ddi: "994" },
    { name: "Bahamas", iso: "bs", ddi: "1" },
    { name: "Bahrain", iso: "bh", ddi: "973" },
    { name: "Bangladesh", iso: "bd", ddi: "880" },
    { name: "Barbados", iso: "bb", ddi: "1" },
    { name: "Belarus", iso: "by", ddi: "375" },
    { name: "Belgium", iso: "be", ddi: "32" },
    { name: "Belize", iso: "bz", ddi: "501" },
    { name: "Benin", iso: "bj", ddi: "229" },
    { name: "Bermuda", iso: "bm", ddi: "1" },
    { name: "Bhutan", iso: "bt", ddi: "975" },
    { name: "Bolivia", iso: "bo", ddi: "591" },
    { name: "Bosnia and Herzegovina", iso: "ba", ddi: "387" },
    { name: "Botswana", iso: "bw", ddi: "267" },
    { name: "Brazil", iso: "br", ddi: "55", mask: "(99) 99999-9999" },
    { name: "British Indian Ocean Territory", iso: "io", ddi: "246" },
    { name: "British Virgin Islands", iso: "vg", ddi: "1" },
    { name: "Brunei", iso: "bn", ddi: "673" },
    { name: "Bulgaria", iso: "bg", ddi: "359" },
    { name: "Burkina Faso", iso: "bf", ddi: "226" },
    { name: "Burundi", iso: "bi", ddi: "257" },
    { name: "Cambodia", iso: "kh", ddi: "855" },
    { name: "Cameroon", iso: "cm", ddi: "237" },
    { name: "Canada", iso: "ca", ddi: "1", mask: "(999) 999-9999" },
    { name: "Cape Verde", iso: "cv", ddi: "238" },
    { name: "Cayman Islands", iso: "ky", ddi: "1" },
    { name: "Central African Republic", iso: "cf", ddi: "236" },
    { name: "Chad", iso: "td", ddi: "235" },
    { name: "Chile", iso: "cl", ddi: "56" },
    { name: "China", iso: "cn", ddi: "86" },
    { name: "Christmas Island", iso: "cx", ddi: "61" },
    { name: "Cocos Islands", iso: "cc", ddi: "61" },
    { name: "Colombia", iso: "co", ddi: "57" },
    { name: "Comoros", iso: "km", ddi: "269" },
    { name: "Cook Islands", iso: "ck", ddi: "682" },
    { name: "Costa Rica", iso: "cr", ddi: "506" },
    { name: "Croatia", iso: "hr", ddi: "385" },
    { name: "Cuba", iso: "cu", ddi: "53" },
    { name: "Curacao", iso: "cw", ddi: "599" },
    { name: "Cyprus", iso: "cy", ddi: "357" },
    { name: "Czech Republic", iso: "cz", ddi: "420" },
    { name: "Democratic Republic of the Congo", iso: "cd", ddi: "243" },
    { name: "Denmark", iso: "dk", ddi: "45" },
    { name: "Djibouti", iso: "dj", ddi: "253" },
    { name: "Dominica", iso: "dm", ddi: "1" },
    { name: "Dominican Republic", iso: "do", ddi: "1" },
    { name: "East Timor", iso: "tl", ddi: "670" },
    { name: "Ecuador", iso: "ec", ddi: "593" },
    { name: "Egypt", iso: "eg", ddi: "20" },
    { name: "El Salvador", iso: "sv", ddi: "503" },
    { name: "Equatorial Guinea", iso: "gq", ddi: "240" },
    { name: "Eritrea", iso: "er", ddi: "291" },
    { name: "Estonia", iso: "ee", ddi: "372" },
    { name: "Ethiopia", iso: "et", ddi: "251" },
    { name: "Falkland Islands", iso: "fk", ddi: "500" },
    { name: "Faroe Islands", iso: "fo", ddi: "298" },
    { name: "Fiji", iso: "fj", ddi: "679" },
    { name: "Finland", iso: "fi", ddi: "358" },
    { name: "France", iso: "fr", ddi: "33" },
    { name: "French Polynesia", iso: "pf", ddi: "689" },
    { name: "Gabon", iso: "ga", ddi: "241" },
    { name: "Gambia", iso: "gm", ddi: "220" },
    { name: "Georgia", iso: "ge", ddi: "995" },
    { name: "Germany", iso: "de", ddi: "49" },
    { name: "Ghana", iso: "gh", ddi: "233" },
    { name: "Gibraltar", iso: "gi", ddi: "350" },
    { name: "Greece", iso: "gr", ddi: "30" },
    { name: "Greenland", iso: "gl", ddi: "299" },
    { name: "Grenada", iso: "gd", ddi: "1" },
    { name: "Guam", iso: "gu", ddi: "1" },
    { name: "Guatemala", iso: "gt", ddi: "502" },
    { name: "Guernsey", iso: "gg", ddi: "44" },
    { name: "Guinea", iso: "gn", ddi: "224" },
    { name: "Guinea-Bissau", iso: "gw", ddi: "245" },
    { name: "Guyana", iso: "gy", ddi: "592" },
    { name: "Haiti", iso: "ht", ddi: "509" },
    { name: "Honduras", iso: "hn", ddi: "504" },
    { name: "Hong Kong", iso: "hk", ddi: "852" },
    { name: "Hungary", iso: "hu", ddi: "36" },
    { name: "Iceland", iso: "is", ddi: "354" },
    { name: "India", iso: "in", ddi: "91" },
    { name: "Indonesia", iso: "id", ddi: "62" },
    { name: "Iran", iso: "ir", ddi: "98" },
    { name: "Iraq", iso: "iq", ddi: "964" },
    { name: "Ireland", iso: "ie", ddi: "353" },
    { name: "Isle of Man", iso: "im", ddi: "44" },
    { name: "Israel", iso: "il", ddi: "972" },
    { name: "Italy", iso: "it", ddi: "39" },
    { name: "Ivory Coast", iso: "ci", ddi: "225" },
    { name: "Jamaica", iso: "jm", ddi: "1" },
    { name: "Japan", iso: "jp", ddi: "81" },
    { name: "Jersey", iso: "je", ddi: "44" },
    { name: "Jordan", iso: "jo", ddi: "962" },
    { name: "Kazakhstan", iso: "kz", ddi: "7" },
    { name: "Kenya", iso: "ke", ddi: "254" },
    { name: "Kiribati", iso: "ki", ddi: "686" },
    { name: "Kosovo", iso: "xk", ddi: "383" },
    { name: "Kuwait", iso: "kw", ddi: "965" },
    { name: "Kyrgyzstan", iso: "kg", ddi: "996" },
    { name: "Laos", iso: "la", ddi: "856" },
    { name: "Latvia", iso: "lv", ddi: "371" },
    { name: "Lebanon", iso: "lb", ddi: "961" },
    { name: "Lesotho", iso: "ls", ddi: "266" },
    { name: "Liberia", iso: "lr", ddi: "231" },
    { name: "Libya", iso: "ly", ddi: "218" },
    { name: "Liechtenstein", iso: "li", ddi: "423" },
    { name: "Lithuania", iso: "lt", ddi: "370" },
    { name: "Luxembourg", iso: "lu", ddi: "352" },
    { name: "Macau", iso: "mo", ddi: "853" },
    { name: "Macedonia", iso: "mk", ddi: "389" },
    { name: "Madagascar", iso: "mg", ddi: "261" },
    { name: "Malawi", iso: "mw", ddi: "265" },
    { name: "Malaysia", iso: "my", ddi: "60" },
    { name: "Maldives", iso: "mv", ddi: "960" },
    { name: "Mali", iso: "ml", ddi: "223" },
    { name: "Malta", iso: "mt", ddi: "356" },
    { name: "Marshall Islands", iso: "mh", ddi: "692" },
    { name: "Mauritania", iso: "mr", ddi: "222" },
    { name: "Mauritius", iso: "mu", ddi: "230" },
    { name: "Mayotte", iso: "yt", ddi: "262" },
    { name: "Mexico", iso: "mx", ddi: "52" },
    { name: "Micronesia", iso: "fm", ddi: "691" },
    { name: "Moldova", iso: "md", ddi: "373" },
    { name: "Monaco", iso: "mc", ddi: "377" },
    { name: "Mongolia", iso: "mn", ddi: "976" },
    { name: "Montenegro", iso: "me", ddi: "382" },
    { name: "Montserrat", iso: "ms", ddi: "1" },
    { name: "Morocco", iso: "ma", ddi: "212" },
    { name: "Mozambique", iso: "mz", ddi: "258" },
    { name: "Myanmar", iso: "mm", ddi: "95" },
    { name: "Namibia", iso: "na", ddi: "264" },
    { name: "Nauru", iso: "nr", ddi: "674" },
    { name: "Nepal", iso: "np", ddi: "977" },
    { name: "Netherlands", iso: "nl", ddi: "31" },
    { name: "New Caledonia", iso: "nc", ddi: "687" },
    { name: "New Zealand", iso: "nz", ddi: "64" },
    { name: "Nicaragua", iso: "ni", ddi: "505" },
    { name: "Niger", iso: "ne", ddi: "227" },
    { name: "Nigeria", iso: "ng", ddi: "234" },
    { name: "Niue", iso: "nu", ddi: "683" },
    { name: "North Korea", iso: "kp", ddi: "850" },
    { name: "Northern Mariana Islands", iso: "mp", ddi: "1" },
    { name: "Norway", iso: "no", ddi: "47" },
    { name: "Oman", iso: "om", ddi: "968" },
    { name: "Pakistan", iso: "pk", ddi: "92" },
    { name: "Palau", iso: "pw", ddi: "680" },
    { name: "Palestine", iso: "ps", ddi: "970" },
    { name: "Panama", iso: "pa", ddi: "507" },
    { name: "Papua New Guinea", iso: "pg", ddi: "675" },
    { name: "Paraguay", iso: "py", ddi: "595" },
    { name: "Peru", iso: "pe", ddi: "51" },
    { name: "Philippines", iso: "ph", ddi: "63" },
    { name: "Poland", iso: "pl", ddi: "48" },
    { name: "Portugal", iso: "pt", ddi: "351" },
    { name: "Puerto Rico", iso: "pr", ddi: "1" },
    { name: "Qatar", iso: "qa", ddi: "974" },
    { name: "Republic of the Congo", iso: "cg", ddi: "242" },
    { name: "Reunion", iso: "re", ddi: "262" },
    { name: "Romania", iso: "ro", ddi: "40" },
    { name: "Russia", iso: "ru", ddi: "7" },
    { name: "Rwanda", iso: "rw", ddi: "250" },
    { name: "Saint Barthelemy", iso: "bl", ddi: "590" },
    { name: "Saint Helena", iso: "sh", ddi: "290" },
    { name: "Saint Kitts and Nevis", iso: "kn", ddi: "1" },
    { name: "Saint Lucia", iso: "lc", ddi: "1" },
    { name: "Saint Martin", iso: "mf", ddi: "590" },
    { name: "Saint Pierre and Miquelon", iso: "pm", ddi: "508" },
    { name: "Saint Vincent and the Grenadines", iso: "vc", ddi: "1" },
    { name: "Samoa", iso: "ws", ddi: "685" },
    { name: "San Marino", iso: "sm", ddi: "378" },
    { name: "Sao Tome and Principe", iso: "st", ddi: "239" },
    { name: "Saudi Arabia", iso: "sa", ddi: "966" },
    { name: "Senegal", iso: "sn", ddi: "221" },
    { name: "Serbia", iso: "rs", ddi: "381" },
    { name: "Seychelles", iso: "sc", ddi: "248" },
    { name: "Sierra Leone", iso: "sl", ddi: "232" },
    { name: "Singapore", iso: "sg", ddi: "65" },
    { name: "Sint Maarten", iso: "sx", ddi: "1" },
    { name: "Slovakia", iso: "sk", ddi: "421" },
    { name: "Slovenia", iso: "si", ddi: "386" },
    { name: "Solomon Islands", iso: "sb", ddi: "677" },
    { name: "Somalia", iso: "so", ddi: "252" },
    { name: "South Africa", iso: "za", ddi: "27" },
    { name: "South Korea", iso: "kr", ddi: "82" },
    { name: "South Sudan", iso: "ss", ddi: "211" },
    { name: "Spain", iso: "es", ddi: "34" },
    { name: "Sri Lanka", iso: "lk", ddi: "94" },
    { name: "Sudan", iso: "sd", ddi: "249" },
    { name: "Suriname", iso: "sr", ddi: "597" },
    { name: "Svalbard and Jan Mayen", iso: "sj", ddi: "47" },
    { name: "Swaziland", iso: "sz", ddi: "268" },
    { name: "Sweden", iso: "se", ddi: "46" },
    { name: "Switzerland", iso: "ch", ddi: "41" },
    { name: "Syria", iso: "sy", ddi: "963" },
    { name: "Taiwan", iso: "tw", ddi: "886" },
    { name: "Tajikistan", iso: "tj", ddi: "992" },
    { name: "Tanzania", iso: "tz", ddi: "255" },
    { name: "Thailand", iso: "th", ddi: "66" },
    { name: "Togo", iso: "tg", ddi: "228" },
    { name: "Tokelau", iso: "tk", ddi: "690" },
    { name: "Tonga", iso: "to", ddi: "676" },
    { name: "Trinidad and Tobago", iso: "tt", ddi: "1" },
    { name: "Tunisia", iso: "tn", ddi: "216" },
    { name: "Turkey", iso: "tr", ddi: "90" },
    { name: "Turkmenistan", iso: "tm", ddi: "993" },
    { name: "Turks and Caicos Islands", iso: "tc", ddi: "1" },
    { name: "Tuvalu", iso: "tv", ddi: "688" },
    { name: "U.S. Virgin Islands", iso: "vi", ddi: "1" },
    { name: "Uganda", iso: "ug", ddi: "256" },
    { name: "Ukraine", iso: "ua", ddi: "380" },
    { name: "United Arab Emirates", iso: "ae", ddi: "971" },
    { name: "United Kingdom", iso: "gb", ddi: "44", mask: "9999 999999" },
    { name: "United States", iso: "us", ddi: "1", mask: "(999) 999-9999" },
    { name: "Uruguay", iso: "uy", ddi: "598" },
    { name: "Uzbekistan", iso: "uz", ddi: "998" },
    { name: "Vanuatu", iso: "vu", ddi: "678" },
    { name: "Vatican", iso: "va", ddi: "379" },
    { name: "Venezuela", iso: "ve", ddi: "58" },
    { name: "Vietnam", iso: "vn", ddi: "84" },
    { name: "Wallis and Futuna", iso: "wf", ddi: "681" },
    { name: "Western Sahara", iso: "eh", ddi: "212" },
    { name: "Yemen", iso: "ye", ddi: "967" },
    { name: "Zambia", iso: "zm", ddi: "260" },
    { name: "Zimbabwe", iso: "zw", ddi: "263" }
];
